import {
  computed, inject, Injectable, resource,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { AuthService } from '@instaclause-webapp/shared-core';
import { firstValueFrom } from 'rxjs';

import { Country, MeClient, MeResponse } from './api/api.service';

@Injectable({ providedIn: 'root' })
export class MeService {
  readonly customerName = computed<string>(() => this.meResource.value()?.customerName ?? '');
  readonly countryCode = computed<Country | null>(
    () => this.meResource.value()?.countryCode ?? null,
  );

  private readonly meClient = inject(MeClient);
  private readonly user = toSignal(inject(AuthService).user$, { initialValue: null });
  private readonly userId = computed<number | null>(() => this.user()?.userId ?? null);

  private meResource = resource<MeResponse | null, number | null>({
    request: () => this.userId(),
    loader: async({ request }) => {
      if (!request) return null;

      return await firstValueFrom(this.meClient.get({ handleError: false }));
    },
  });
}
